// Downloads Tag Badge Component
// Displays a selected tag with an X button to remove it

import './DownloadsTagBadge.css';

export function DownloadsTagBadge({ tag, onRemove, className = '' }) {
  return (
    <div className={`downloads-tag-badge ${className}`}>
      <span className="downloads-tag-badge-text">{tag}</span>
      <button
        type="button"
        className="downloads-tag-badge-remove"
        onClick={onRemove}
        aria-label={`Remove ${tag} tag`}
        title={`Remove ${tag} tag`}
      >
        <i className="fa-solid fa-xmark" aria-hidden></i>
      </button>
    </div>
  );
}
